var app = angular.module("leonardo");

var UnitTypeListActions = function($scope, ngDialog, $timeout, PermissionService, AccountService, AuthDataService) {

  $scope.permissionService = PermissionService;

  $scope.showAddUnitTypeDialogAdd = function() {
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account'
      }).then(function (account) {
        if (account) {
          $timeout(function() {
            ngDialog.open({
              template: 'views/templates/dialog/unit/unit-type-form.html',
              controller: 'UnitTypeForm',
              data: {
                mode: 'create',
                account: (account !== 'all') ? account : null
              }
            });
          }, 200);
        }
      });
    }
    else {
      ngDialog.open({
        template: 'views/templates/dialog/unit/unit-type-form.html',
        controller: 'UnitTypeForm',
        data: {
          mode: 'create',
          account: AuthDataService.authData.account.id
        }
      });
    }
  };
};

app.controller('UnitTypeListActions', ['$scope', 'ngDialog', '$timeout', 'PermissionService', 'AccountService', 'AuthDataService', UnitTypeListActions]);
